'use client';

import { useCallback, useState } from 'react';

import { defaultPerPageOptions } from '../constants/pagination';
import { getTablePerPageState, setTablePerPageState } from '../utils/tableState';

export function usePagination({
  defaultPerPage = defaultPerPageOptions[0],
  initialPage = 0,
  perPageOptions = defaultPerPageOptions,
  tableId,
}: {
  defaultPerPage?: number;
  initialPage?: number;
  perPageOptions?: number[];
  tableId?: string;
} = {}) {
  const [tablePage, setTablePage] = useState(initialPage);
  const [perPage, setPerPage] = useState(() => {
    if (!tableId) {
      return defaultPerPage;
    }

    const perPageState = getTablePerPageState(tableId);

    if (perPageState && perPageOptions.includes(perPageState)) {
      return perPageState;
    }

    return defaultPerPage;
  });

  const handleSetPerPage = useCallback(
    (perPage: number) => {
      setTablePage(0);
      setPerPage(perPage);
      if (tableId) {
        setTablePerPageState(tableId, perPage);
      }
    },
    [tableId],
  );

  return {
    apiPage: tablePage + 1,
    perPage,
    setPerPage: handleSetPerPage,
    setTablePage,
    tablePage,
  };
}
